import axios from 'axios'

/**
 * キープアライブサービス
 */
export default class KeepAliveService {
    /** インスタンス */
    private static _instance: KeepAliveService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new KeepAliveService();
        }
        return this._instance;
    }

    /**
     * バージョン番号を取得
     */
    public async keepAlive(): Promise<string> {
        return await axios.get("/api/keep_alive")
            .then((results) => {
                if (results.status === 200) {
                    return results.data.status
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
